import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import AboutPage from '../pages/about/page';
import CollectionsPage from '../pages/collections/page';
import LivingRoomPage from '../pages/collections/living-room/page';
import BedroomPage from '../pages/collections/bedroom/page';
import DiningRoomPage from '../pages/collections/dining-room/page';
import HomeOfficePage from '../pages/collections/home-office/page';
import OutdoorPage from '../pages/collections/outdoor/page';
import ShowroomPage from '../pages/showroom/page';
import ReviewsPage from '../pages/reviews/page';
import FaqPage from '../pages/faq/page';
import GalleryPage from '../pages/gallery/page';
import ContactPage from '../pages/contact/page';

const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/collections', element: <CollectionsPage /> },
  { path: '/collections/living-room', element: <LivingRoomPage /> },
  { path: '/collections/bedroom', element: <BedroomPage /> },
  { path: '/collections/dining-room', element: <DiningRoomPage /> },
  { path: '/collections/home-office', element: <HomeOfficePage /> },
  { path: '/collections/outdoor', element: <OutdoorPage /> },
  { path: '/showroom', element: <ShowroomPage /> },
  { path: '/reviews', element: <ReviewsPage /> },
  { path: '/faq', element: <FaqPage /> },
  { path: '/gallery', element: <GalleryPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
